module.exports = __webpack_public_path__ + "img/pink_mannequin_3.cd1c80f2.png";